/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import {
  Heading,
  Paragraph,
  Collapsible,
  Button,
  HtmlParser,
} from 'components/common';

import './MoreAboutProviderPanel.scss';

class MoreAboutProviderPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowMore: false,
    };

    this.toggleIsShowMore = this.toggleIsShowMore.bind(this);
  }

  toggleIsShowMore() {
    this.setState(({ isShowMore }) => ({
      isShowMore: !isShowMore,
    }));
  }

  render() {
    const { isShowMore } = this.state;
    const {
      title,
      showMoreLabel,
      showLessLabel,
      moreAboutProvider,
    } = this.props;

    return (
      <div className="more-about-provider">
        <hr className="divider" />
        <div className="more-about-provider-header">
          <Heading as="h3">
            {title}
          </Heading>
        </div>
        <div className={classNames({
          'more-about-provider-content': true,
          'alpha-layer': !isShowMore,
        })}
        >
          <Collapsible
            collapsedHeightValue={1.25 * 2}
            collapsedHeightUnit="em"
            isCollapsed={!isShowMore}
          >
            <Paragraph>
              <HtmlParser htmlString={moreAboutProvider} />
            </Paragraph>
          </Collapsible>
        </div>
        <div className="more-about-provider-show-more-button" onClick={this.toggleIsShowMore}>
          <Button
            text
            rightIconName={isShowMore ? 'chevron_up' : 'chevron_down'}

          >
            {isShowMore ? showLessLabel : showMoreLabel}
          </Button>
        </div>
      </div>
    );
  }
}

MoreAboutProviderPanel.propTypes = {
  title: string.isRequired,
  showMoreLabel: string.isRequired,
  showLessLabel: string.isRequired,
  moreAboutProvider: string.isRequired,
};

export default MoreAboutProviderPanel;
